"use client";

import { c as _c } from "react/compiler-runtime";
import { ApiParametersType } from "@/types/network";
import { useDocumentActionsContext } from "@hooks/pages/use-document-actions";
import { useRouteInfo } from "@hooks/pages/use-route-info";
import { IconHome } from "@tabler/icons-react";
import React, { useMemo } from "react";
import { useLocale } from "next-intl";
import Link from "next/link";
import { useParams } from "next/navigation";
import { extractEntityTitleForFromDocumentContext } from "@components/document/document-title";
import { Breadcrumb, BreadcrumbEllipsis, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@components/ui/breadcrumb";
import { useSidebar } from "@components/ui/sidebar";
import { localizeFrom, useAnyTranslations } from "@lib/i18n/utils";
import { useAppSelector } from "@lib/redux/hooks";
import { cn } from "@lib/utils";
import routes from "@features/routes";
import { selectCurrentWorkspace } from "@features/workspaces/workspaces-selectors";
interface PageBreadcrumbProps {
  overrideTitle?: string;
}
export const PageBreadcrumb = t0 => {
  const $ = _c(38);
  const {
    overrideTitle
  } = t0;
  const tAny = useAnyTranslations();
  const locale = useLocale();
  const routeInfo = useRouteInfo();
  const documentActions = useDocumentActionsContext();
  const {
    state
  } = useSidebar();
  const {
    idOrSlug,
    eventId
  } = useParams();
  const currentWorkspace = useAppSelector(selectCurrentWorkspace);
  const page = routeInfo.page;
  const pageTitleKey = page?.localizationKeys.title;
  const isHomePage = page?.pathTemplate === routes.application.pages.home.pathTemplate;
  documentActions.state?.entity;
  let t1;
  if ($[0] !== documentActions.state?.entity || $[1] !== locale || $[2] !== overrideTitle || $[3] !== pageTitleKey || $[4] !== tAny) {
    bb0: {
      if (overrideTitle) {
        t1 = overrideTitle;
        break bb0;
      }
      if (!pageTitleKey) {
        t1 = null;
        break bb0;
      }
      const entityTitle = extractEntityTitleForFromDocumentContext(documentActions.state?.entity);
      if (entityTitle) {
        let t2;
        if ($[6] !== pageTitleKey || $[7] !== tAny) {
          t2 = tAny(pageTitleKey);
          $[6] = pageTitleKey;
          $[7] = tAny;
          $[8] = t2;
        } else {
          t2 = $[8];
        }
        t1 = `${t2} - ${localizeFrom(entityTitle, locale)}`;
        break bb0;
      }
      let t2;
      if ($[9] !== pageTitleKey || $[10] !== tAny) {
        t2 = tAny(pageTitleKey);
        $[9] = pageTitleKey;
        $[10] = tAny;
        $[11] = t2;
      } else {
        t2 = $[11];
      }
      t1 = t2;
    }
    $[0] = documentActions.state?.entity;
    $[1] = locale;
    $[2] = overrideTitle;
    $[3] = pageTitleKey;
    $[4] = tAny;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const currentRouteTitle = t1;
  let t2;
  let t3;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = routes.application.pages.home.path();
    t3 = <IconHome className="h-4 w-4 xl:hidden" />;
    $[12] = t2;
    $[13] = t3;
  } else {
    t2 = $[12];
    t3 = $[13];
  }
  let t4;
  if ($[14] !== tAny) {
    t4 = tAny(routes.application.pages.home.localizationKeys.title);
    $[14] = tAny;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t4) {
    t5 = <BreadcrumbItem className="hidden md:block"><BreadcrumbLink asChild={true}><Link href={t2}>{t3}<span className="hidden xl:block">{t4}</span></Link></BreadcrumbLink></BreadcrumbItem>;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const HomeLink = t5;
  let t6;
  bb1: {
    if (!page || page.feature === routes.application.feature) {
      t6 = null;
      break bb1;
    }
    const showWorkspaceCrumb = !(page.breadcrumbOptions?.skipWorkspace || page.parentPage?.breadcrumbOptions?.skipWorkspace);
    const showWorkspaceHint = !!currentWorkspace;
    let t7;
    if ($[18] !== currentWorkspace || $[19] !== showWorkspaceCrumb || $[20] !== showWorkspaceHint) {
      t7 = showWorkspaceCrumb && <><BreadcrumbSeparator className="hidden lg:block" />{!showWorkspaceHint && <BreadcrumbItem className="hidden lg:block"><BreadcrumbEllipsis /></BreadcrumbItem>}{showWorkspaceHint && <BreadcrumbItem className="hidden lg:block"><BreadcrumbPage className="max-w-30 truncate">{currentWorkspace.hint}</BreadcrumbPage></BreadcrumbItem>}</>;
      $[18] = currentWorkspace;
      $[19] = showWorkspaceCrumb;
      $[20] = showWorkspaceHint;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    let t8;
    if ($[22] !== eventId || $[23] !== idOrSlug || $[24] !== page.parentPage || $[25] !== tAny) {
      t8 = page.parentPage && <><BreadcrumbSeparator className="hidden lg:block" /><BreadcrumbItem className="hidden lg:block"><BreadcrumbLink asChild={true}><Link href={page.parentPage.path({
              idOrSlug,
              eventId
            })}>{tAny(page.parentPage.localizationKeys.title)}</Link></BreadcrumbLink></BreadcrumbItem></>;
      $[22] = eventId;
      $[23] = idOrSlug;
      $[24] = page.parentPage;
      $[25] = tAny;
      $[26] = t8;
    } else {
      t8 = $[26];
    }
    let t9;
    if ($[27] !== t7 || $[28] !== t8) {
      t9 = <>{t7}{t8}</>;
      $[27] = t7;
      $[28] = t8;
      $[29] = t9;
    } else {
      t9 = $[29];
    }
    t6 = t9;
  }
  const SecondaryBreadcrumbItems = t6;
  let t7;
  if ($[30] !== currentRouteTitle || $[31] !== isHomePage || $[32] !== state) {
    t7 = currentRouteTitle && !isHomePage && <><BreadcrumbSeparator className="hidden md:block" /><BreadcrumbItem className={cn("inline-block truncate xl:max-w-full", {
        "max-w-30 md:max-w-80 lg:max-w-120": state === "collapsed",
        "max-w-30 md:max-w-50 lg:max-w-80": state === "expanded"
      })}><BreadcrumbPage className="truncate">{currentRouteTitle}</BreadcrumbPage></BreadcrumbItem></>;
    $[30] = currentRouteTitle;
    $[31] = isHomePage;
    $[32] = state;
    $[33] = t7;
  } else {
    t7 = $[33];
  }
  let t8;
  if ($[34] !== HomeLink || $[35] !== SecondaryBreadcrumbItems || $[36] !== t7) {
    t8 = <Breadcrumb><BreadcrumbList>{HomeLink}{SecondaryBreadcrumbItems}{t7}</BreadcrumbList></Breadcrumb>;
    $[34] = HomeLink;
    $[35] = SecondaryBreadcrumbItems;
    $[36] = t7;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  return t8;
};